import jwtAxios from '@tenant/services/auth/jwt-auth';

export const APP_PACKAGE_APIS = {
  ROOT: 'api/app-packages',
  DELETE_APP_COMPONENT:
    'api/app-packages/:appPackageId/components/:componentId',
  ADD_APP_COMPONENT: 'api/app-packages/:appPackageId/components/add',
  SELECT_BY_APP_IDS: 'api/app-packages/get-by-app-ids',
};

export const getListAppPackageQuery = (params) => {
  return jwtAxios.get(APP_PACKAGE_APIS.ROOT, { params });
};

export const getDetailAppPackageQuery = (id) => {
  return jwtAxios.get(APP_PACKAGE_APIS.ROOT + '/' + id);
};

export const addAppPackageQuery = (payload) => {
  return jwtAxios.post(APP_PACKAGE_APIS.ROOT, payload);
};

export const addAppComponentQuery = ({ appPackageId, components }) => {
  return jwtAxios.post(
    APP_PACKAGE_APIS.ADD_APP_COMPONENT.replace(':appPackageId', appPackageId),
    components,
  );
};

export const deleteAppPackageQuery = (payload) => {
  return jwtAxios.delete(APP_PACKAGE_APIS.ROOT + '/' + payload.Id);
};

export const upgradeVersionAppPackageQuery = (payload) => {
  return jwtAxios.put(
    APP_PACKAGE_APIS.ROOT +
      '/' +
      payload.Id +
      ':upgrade-to-latest-image-versions',
  );
};

export const deleteAppComponentQuery = (payload) => {
  return jwtAxios.delete(
    APP_PACKAGE_APIS.DELETE_APP_COMPONENT.replace(
      ':appPackageId',
      payload.appPackageId,
    ).replace(':componentId', payload.componentId),
  );
};
